/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Fragment, useState } from "react";
import posthog from "posthog-js";
import { useQuery } from "@tanstack/react-query";

import useAppSelector from "@/hooks/useAppSelector";
import { recombeeToCart } from "@/utils/product";

import SwiperSectionProductGallerySmall from "@/components/Organisms/SwiperSectionProductGallerySmall";
import type { RecombeeValuesItemUser } from "@/types/recombee";

import { getMostPurchaseRecommendations } from "@/services/recombee";
import useSessionContext from "@/hooks/useSesionContext";
import Card from "@/components/Atoms/Card";
import { stylesWrapperCard } from "@/components/Organisms/MiscellaneousSectionProductGallery/styles";
import { InView } from "react-intersection-observer";
import tw from "twin.macro";

const YourMostPurchased = ({ showCard = true }: { showCard?: boolean }) => {
  const { isAthenticated } = useSessionContext();
  const storeId = useAppSelector((state) => state.cart.storeId);
  const userID = posthog.get_distinct_id();
  const [inView, setInView] = useState(false);

  const {
    data: mostPurchased,
    error,
    isFetching,
  } = useQuery({
    queryKey: ["mostPurchaseProducts", userID, storeId, isAthenticated()],
    queryFn: async () => {
      const result = await getMostPurchaseRecommendations(userID, String(storeId));

      if (!result.data?.success) {
        throw new Error("No data");
      }

      const { payload } = result.data;

      const items: Cart[] = payload.map(({ id, values }: { id: string; values: RecombeeValuesItemUser }) =>
        recombeeToCart(Number(id), storeId!, values)
      );

      return {
        items,
      };
    },
    enabled: !!userID && !!storeId && isAthenticated() && inView,
  });

  if (!isAthenticated()) {
    return null;
  }

  if (error || !storeId || !userID) {
    return null;
  }

  if (isFetching) {
    return null;
  }

  if (mostPurchased?.items && mostPurchased.items.length <= 0) {
    return null;
  }

  return (
    <InView
      onChange={(isView) => {
        if (!inView) setInView(isView);
      }}
      css={[inView ? tw`block opacity-100` : tw`absolute opacity-100`]}
      rootMargin="100px 0px"
      triggerOnce
    >
      {inView && mostPurchased && (
        <Card
          as={showCard ? "section" : Fragment}
          classes={{
            root: stylesWrapperCard,
          }}
        >
          <SwiperSectionProductGallerySmall items={mostPurchased?.items ?? []} title={"Compras anteriores"} />
        </Card>
      )}
    </InView>
  );
};

export default YourMostPurchased;
